import { render, staticRenderFns } from "./comJSONData.vue?vue&type=template&id=83d37954&"
import script from "./comJSONData.vue?vue&type=script&lang=js&"
export * from "./comJSONData.vue?vue&type=script&lang=js&"
import style0 from "./comJSONData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports